import {ChangeRequestReview} from 'src/openapi/models/ChangeRequestReview';

export const checkRisksAndRecommendations = (
    review: ChangeRequestReview,
): boolean => {
    const allFields = [
        ...(review?.changeRequestFieldsReviews ?? []),
        ...(review?.eventFieldsReviews ?? []),
        ...(review?.attributesReviews ?? []),
    ];

    return allFields.some(
        field =>
            (field.risks && field.risks.length > 0) ||
            (field.recommendations && field.recommendations.length > 0),
    );
};
